(() => {
  const cleanup = () => {
    document.getElementById('BhaktiFastCartStyle')?.remove();
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawer.removeAttribute('data-bhakti-pending');
    if (drawer.__bhaktiPendingTimer) {
      clearTimeout(drawer.__bhaktiPendingTimer);
      drawer.__bhaktiPendingTimer = null;
    }
  };

  cleanup();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanup, { once: true });
  }
  document.addEventListener('shopify:section:load', cleanup);
})();
